<template>
<div class="hris-page">
	<div class="hris-page-inner">
		<div class="hris-page-header">
			<span class="hris-page-eyebrow">System Settings</span>
			<h1 class="hris-page-title">Position</h1>
			<p class="hris-page-subtitle">Manage the list of positions available within each department.</p>
		</div>

		<q-form ref="vForm" @submit="onSubmit">
			<div class="row q-col-gutter-lg">
				<div class="col-12 col-md-4">
					<div class="hris-form-section">
						<h2 class="hris-form-section-title">Add / Edit Position</h2>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-select outlined dense color="green" v-model="department" option-value="id" option-label="name" :rules="[formRules.required]" :options="departmentOptions" label="Department" emit-value map-options></q-select>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<q-input outlined dense color="green" v-model="position" label="Position" :rules="[formRules.required]" class="caps"></q-input>
							</div>
						</div>
						<div class="hris-form-row">
							<div class="hris-form-field">
								<label class="hris-form-label">Status</label>
								<div class="q-gutter-sm">
									<q-radio keep-color color="green" v-model="is_active" val="Y" label="Active" :rules="[formRules.required]"></q-radio>
									<q-radio keep-color color="green" v-model="is_active" val="N" label="In-active" :rules="[formRules.required]"></q-radio>
								</div>
							</div>
						</div>
						<div class="hris-form-actions">
							<q-btn unelevated class="hris-q-primary full-width" type="submit" label="Save"></q-btn>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-8">
					<div class="hris-panel">
						<h2 class="hris-panel-title">Position List</h2>
						<q-table
							flat
							:data="data"
							:columns="columns"
							row-key="id"
							:pagination.sync="pagination"
						>
							<template v-slot:body="props">
								<q-tr slot="body" :props="props" @click="selectedRow(props)" style="cursor: pointer;">
									<q-td key="id" :props="props">{{ props.row.counter }}</q-td>
									<q-td key="dept" :props="props">{{ props.row.dept }}</q-td>
									<q-td key="name" :props="props">{{ props.row.name }}</q-td>
									<q-td key="is_active" :props="props">
										<span class="hris-badge" :class="props.row.is_active == 'Y' ? 'hris-badge-success' : 'hris-badge-danger'">
											{{ props.row.is_active == 'Y' ? 'Active' : 'Inactive' }}
										</span>
									</q-td>
									<q-td key="action" :props="props">
										<q-btn flat round dense class="hris-q-ghost" @click="removeRow(props)">
											<i class="fas fa-trash"></i>
											<q-tooltip anchor="top middle" self="bottom middle" :offset="[10, 10]">
												<strong>Remove</strong>
											</q-tooltip>
										</q-btn>
									</q-td>
								</q-tr>
							</template>
							<template v-slot:no-data="">
								<div class="hris-empty full-width">
									No results found.
								</div>
							</template>
						</q-table>
					</div>
				</div>
			</div>
		</q-form>

		<q-dialog v-model="spinner" persistent>
			<div class="hris-loading" style="background: #fff; border-radius: 14px; padding: 32px 44px;">
				<q-spinner color="green" size="40px"></q-spinner>
			</div>
		</q-dialog>

		<q-dialog v-model="deleted" persistent>
			<div class="hris-modal">
				<div class="hris-modal-header">
					<h2 class="hris-modal-title">Confirm Deletion</h2>
				</div>
				<div class="hris-modal-body">
					This record will be permanently deleted.
				</div>
				<div class="hris-modal-footer">
					<q-btn flat label="Cancel" class="hris-q-ghost" v-close-popup></q-btn>
					<q-btn unelevated label="Delete" class="hris-q-primary" v-close-popup @click="deletionConfirmation"></q-btn>
				</div>
			</div>
		</q-dialog>
	</div>
</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';


export default {

	data () {
		return {
			departmentOptions:[],
			department:null,
			tempID:0,
			spinner:false,
			deleted:false,
			position:null,
			is_active:'Y',
			data:[],
			type:'position',
			columns: [
			{ name: 'id', align: 'center', label: 'ID', field: 'id', sortable: true },
			{ name: 'dept', align: 'center', label: 'Department', field: 'dept', sortable: true },
			{ name: 'name', align: 'center', label: 'Position', field: 'name', sortable: true },
			{ name: 'is_active', align: 'center', label: 'Status', field: 'is_active' , sortable: true},
			{ name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
			],
			pagination: {
				rowsPerPage: 20
			},
		}
	},

	created(){
		this.displayData()
		this.displayDepartment()
	},

	methods: {

		onSubmit : function(){
			this.spinner = true;
			let formData = new FormData();

			formData.append("dept_id", this.department);
			formData.append("name", this.position);
			formData.append("type", this.type);
			formData.append("status", this.is_active);
			formData.append("tempID", this.tempID);

			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/setting/relationship',formData)
			.then((res) => {
				this.displayData()
				this.position = ''
				this.department = ''
				this.is_active = ''
				this.tempID = 0
				this.spinner = false;
				this.$refs.vForm.reset()
			});
		},

		displayData: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/setting/${this.type}`)
			.then((res) => {
				this.data = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})

		},

		selectedRow:function(obj){
			this.department = obj.row.dept_id
			this.position = obj.row.name
			this.is_active = obj.row.is_active
			this.tempID = obj.row.id
		},

		removeRow:function(obj){
			this.deleted = true
			this.tempID = obj.row.id
		},

		deletionConfirmation:function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("tempID", this.tempID);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/setting/delete',formData)
			.then((res) => {
				this.tempID = 0
				this.displayData()
			});
		},

		displayDepartment: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/department`)
			.then((res) => {
				this.departmentOptions = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})
		},

	}
}
</script>
<style>
.caps {
	text-transform: uppercase
}
</style>
